import router from './router'
import fraudMessages from './localization'

export default {
  router,
  localization: fraudMessages,
}
